import React from "react";
import { Chip, TableCell, TableRow } from "@mui/material";
import { translate } from "../../services/Translations/translatorService.tsx";
import executionJobStepRowStyles from "./executionJobStepRowStyles.ts";
import dayjs from "dayjs";
import { ExecutionStep } from "../../types/ExecutionJob/ExecutionStep.ts";

type ExecutionJobStepRowProps = {
  step: ExecutionStep;
};

const ExecutionJobStepRow = ({ step }: ExecutionJobStepRowProps) => {

  return (
    <>
      <TableRow
        sx={{
          opacity: step.status === "skipped" ? 0.65 : 1,
        }}
      >
        <TableCell>
          <Chip
            size={"small"}
            label={translate(`executionJob.step.actionType.values.${step.actionType}`, step.actionType)}
            sx={executionJobStepRowStyles.actionTypeChipSxByActionType[step.actionType]}
          />
        </TableCell>
        <TableCell>
          <Chip
            size={"small"}
            label={translate(`executionJob.step.status.values.${step.status}`, step.status)}
            sx={executionJobStepRowStyles.stepStatusChipSxByStatus[step.status]}
          />
        </TableCell>
        <TableCell>
          {["completed", "failed", "skipped"].includes(step.status) &&
            dayjs(step.executedAt).format("DD.MM.YYYY HH:mm")}
        </TableCell>
      </TableRow>
    </>
  );
};

export default ExecutionJobStepRow;
